import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Wordmark } from "./Wordmark";
import { PEE_FULL_NAME, PEE_SHORT_EXPLANATION, SYSTEM_DESCRIPTOR } from "@/lib/looseend/pee";
import { useState } from "react";

/** Mobile header wordmark: tapping opens a compact product-information popover. */
export function MobileBrandPopover() {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="mx-auto min-w-0"
          aria-label="About L∞seEnd, Personal Execution System, powered by P-E-E, Personal Execution Engine"
        >
          <Wordmark className="text-[16px]" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="center" className="w-[280px] rounded-2xl">
        <div className="flex items-start gap-2">
          <div className="min-w-0 flex-1">
            <Wordmark className="text-[15px]" aria-hidden="true" />
            <p aria-hidden="true" className="mt-0.5 text-[12px] font-medium text-foreground/80">
              {SYSTEM_DESCRIPTOR}
            </p>
            <p aria-hidden="true" className="mt-1 text-[11px] text-muted-foreground">
              Powered by <span className="text-primary">PEE™</span>
            </p>
            <p aria-hidden="true" className="text-[10px] text-muted-foreground/80">
              {PEE_FULL_NAME}
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Dismiss"
            className="-mr-1 -mt-1 size-7 shrink-0"
            onClick={() => setOpen(false)}
          >
            <X className="size-4" aria-hidden="true" />
          </Button>
        </div>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          {PEE_SHORT_EXPLANATION}
        </p>
      </PopoverContent>
    </Popover>
  );
}
